import { useDisclosure } from '@chakra-ui/react';
import React from 'react';

import {
  CmBox,
  CmButton,
  CmHeading,
  CmModal,
  CmModalBody,
  CmModalFooter,
  CmText,
} from '@/components/uiParts';
import { TABLET_API_ORIGIN } from '@/global/env';

import UberScreenImage from './uber-screen.png';

const TITLE = 'Uber Eats一括認証';
export const UberAuthBulkActivateV2Modal: React.FC = () => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  return (
    <>
      {/*
       // @ts-ignore TS2590 */}
      <CmButton colorScheme="teal" onClick={onOpen}>
        {TITLE}
      </CmButton>
      <CmModal
        {...{
          isOpen,
          onClose,
          title: '◾ ' + TITLE,
          size: '4xl',
        }}
      >
        <CmModalBody pb="10">
          <CmBox>
            <CmText>
              Uber Eatsレストランマネージャーアカウントを使用して、CamelとUber
              Eatsを連携させましょう！
            </CmText>
            <CmText>
              現時点で貴社Uber
              Eatsアカウントに紐づくすべての店舗から、Camelと連携する店舗を選択する作業となります。
            </CmText>
            <CmText fontSize="12px" paddingTop="5">
              ※ 認証後、Uber
              Eats店舗を追加した場合は、再度認証を行う必要があります。
            </CmText>
          </CmBox>
          <CmBox mt="30px">
            <CmHeading as="h4" size="lg" paddingBottom="5">
              ◾️ ご準備いただくもの
            </CmHeading>
            <CmText>
              ・Uber
              Eatsレストランマネージャーアカウントのログイン情報（メールアドレス、パスワード）
            </CmText>
            <CmText fontSize="12px" paddingTop="5" paddingBottom="2">
              ※
              全ての店舗情報を閲覧・管理することが可能なアカウントをご準備ください。
            </CmText>
            <CmBox width="60%">
              <img
                src={UberScreenImage}
                alt="Uber Eatsレストランマネージャー画面例"
              />
              <CmText fontSize="14px" textAlign="center" mt="5px">
                Uber Eatsレストランマネージャー画面例
              </CmText>
            </CmBox>
          </CmBox>

          <CmBox mt="30px">
            <CmHeading as="h4" size="lg" paddingBottom="5">
              ◾️ 手順
            </CmHeading>
            <CmText>
              1. 当ページ右下の「認証を行う」ボタンをクリックすると、Uber
              Eatsログイン画面にリダイレクトされます。
            </CmText>
            <CmText>
              2. レストランマネージャーアカウントのログイン情報を入力後、「Uber
              Eats店舗認証」画面にリダイレクトされます。
            </CmText>
            <CmText>
              3. 連携を行いたいUber
              Eats店舗認証を選択し、認証を行ってください。（認証完了後、「店舗一覧」画面にリダイレクトされます。）
            </CmText>
            <CmText>
              4. 「店舗一覧」画面のデリバリーサービス連携で、認証を行ったUber
              Eats店舗を選択し、Camelとの連携を行ってください。
            </CmText>
          </CmBox>
        </CmModalBody>
        <CmModalFooter>
          <a
            href={`${TABLET_API_ORIGIN}/dashboard-api/oauth/uber/authorize/stores/activate/v2`}
          >
            <CmButton colorScheme="teal" onClick={onOpen}>
              認証を行う
            </CmButton>
          </a>
          <CmButton ml="3" variant="outline" onClick={onClose}>
            閉じる
          </CmButton>
        </CmModalFooter>
      </CmModal>
    </>
  );
};
